import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PwaUtilsService {
  private subject = new BehaviorSubject<{ width: number; height: number }>({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  private breakpointWidth: number;

  constructor() {
    this.breakpointWidth = Number(
      (
        getComputedStyle(document.documentElement).getPropertyValue(
          '--boxx-vertical-tabs-breakpoint'
        ) || '768px'
      ).replace('px', '')
    );

    window.onresize = () => {
      this.onWindowResize();
    };
    this.onWindowResize();
  }

  getBreakpointWidth() {
    return this.breakpointWidth;
  }

  get reportWindowResize$() {
    return this.subject.asObservable();
  }

  private onWindowResize() {
    this.subject.next({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }
}
